var createNamedExpression = function (name, args) {
  return {
    $: name,
    args: args
  };
};
export default createNamedExpression;
